﻿

(() => {
    //todo move this service to another file
    angular.module('fliptoWeb')
        .factory('headService', ['$window', function ($window) {

        var service: any = {
            socialShareTitle: $window.socialShareTitle || "",
            socialShareContent: $window.socialShareContent || "",
            socialFeaturedImage: $window.socialFeaturedImage || "",
            currentUrl: () => { return $window.location.href }
        };

        return service;
    }]);

    angular.module('fliptoWeb')
        .controller('HeadCtrl', ['headService',
        function (headService) {
            var vm = this;

            vm.socialShareTitle = () => { return headService.socialShareTitle };
            vm.socialShareContent = () => { return headService.socialShareContent };
            vm.socialFeaturedImage = () => { return headService.socialFeaturedImage };
            vm.currentUrl = ()=> { return headService.currentUrl() };

            vm.debug = JSON.stringify(vm, null, 2);
            return vm;
        }]);
})()
